// VA Logon Modal

jQuery('[data-csp]').click(function(e){

  switch( jQuery(this).data('csp') ) {
    case 'idme':
      window.location.href = "https://www.id.me/session/new";
      break;
    case 'dslogon':
      window.location.href = "https://myaccess.dmdc.osd.mil/identitymanagement/authenticate.do?execution=e1s1";
      break;
    case 'mhv':
      window.location.href = "https://mhvidp-prod.myhealth.va.gov/mhv-portal-web/web/guest/home?p_p_state=maximized&p_p_mode=view&saveLastPath=false&_58_struts_action=%2Flogin%2Flogin&p_p_id=58&p_p_lifecycle=0&_58_redirect=%2Fmhv-portal-web%2Fc%2Fportal%2Fsaml%2Fsso";
      break;
    default:
      console.log( jQuery(this).data('csp') );
  }
  
});